
<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row" *ngIf="CurrentCounsellingPlanController">
        <!--<div class="col-md-1 padding-left-0px padding-right-0px">
          <a class="education-navlink addicon-circle">
            <span class="badge">

              <i class="fas fa-user-plus"></i>
            </span>
          </a>
        </div>-->
        <div class="col-md-4 padding-left-9px padding-right-0px">
          <label class="margin-top-3px">Profile</label>
        </div>
        <div class="col-md-6 padding-left-0px">
          <ul class="nav nav-tabs nav-tab-plan margin-top-4px" id="tabContent">
            <li *ngIf="CurrentCounsellingPlanController.length>0" class="active margin-right-30px"><a class="nav-item3 " href="#details" data-toggle="tab">Active Plan</a></li>
            <!--<li *ngIf="CurrentCounsellingPlanController.length==0"><a class="nav-item3" href="#access-security" data-toggle="tab">New Plan</a></li>-->
            <li ><a class="nav-item3" href="#access-security" data-toggle="tab">New Plan</a></li>

          </ul>
        </div>
        <div class="col-md-2">
          <button type="button" class="close float-right margin-top-4px" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!--<div class="col-md-8 float-right" *ngIf="CurrentCounsellingPlanController.length==0">
          <div class="row">
            <div class="col-md-8">
              <label class="margin-top-3px"> Add Proposed Plan</label>
            </div>
            <div class="col-md-4">
              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

        </div>
        <div class="col-md-8 float-right" *ngIf="CurrentCounsellingPlanController.length>0">
          <div class="row">
            <div class="col-md-8">
              <label class="margin-top-3px"> Counselling Plan (Active)</label>
            </div>
            <div class="col-md-4">
              <button type="button" class="close" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

        </div>-->
      </div>



    </div>
  
      <div class="modal-body padding-top-0px counselling-modal">

        <div class="row" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
          <div class="position-fixed-counselling">
            <div class=" card bk-color-light2 card-height">
              <div class="row margin-top-10">
                <div class="offset-md-3 col-md-3 padding-left-0px">
                  <img  class="img-circle-50 margin-left-10px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">
                  <!--<img  class="img-circle-50 margin-left-10px" *ngIf="!l.PatientImageFile" src="dummy.jpg">-->
                </div>
              </div>
              <div class="row">
                <div class="offset-md-2 col-md-8 padding-left-0px padding-right-0px text-align-center">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-3 col-md-7">
                  <label class="margin-bottom-0px">{{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-3 col-md-8">
                  <label class="margin-bottom-0px">
                    <!--32yrs,Female-->
                    {{l.Age}},{{l.Gender}}
                  </label>
                </div>
              </div>
              <div class="row">
                <!--<div class="col-md-3">
          <label>Phone Number:</label>
        </div>-->
                <div class="offset-md-3 col-md-6">
                  {{l.Telephone1}}
                </div>
              </div>
            </div>
            </div>
            <div class="offset-md-4 col-md-8">
              <div class="tab-content">
                <div class="tab-pane" id="access-security">

                  <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

                    <div class="col-md-12">
                      <div class="row margin-top-10 ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch</label>
                            </div>


                            <div class="col-md-5">
                              <CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                       id="CurrentSaveCounsellingPlanRequest.BranchCode" SelectedValue=""
                                                       [(ngModel)]="CurrentSaveCounsellingPlanRequest.BranchCode" (keyChange)="onAssignedToActorCode($event)"
                                                       name="CurrentSaveCounsellingPlanRequest.BranchCode" required>
                              </CustomDataByRequestType>

                              <!--<label>{{FacilityShortName}}</label>-->
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10 ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                            </div>


                            <div class="col-md-5">
                              <CodeTypeValue CodeType="CNSPN"
                                             id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                             [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                             name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                              </CodeTypeValue>


                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                            </div>


                            <div class="col-md-5">
                              <div class="date-form">
                                <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                       name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                                <small class="form-text text-danger"
                                       *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                <a (click)="d.toggle()" class="nav-link-hand">
                                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                </a>

                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row  ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                            </div>


                            <div class="col-md-5">
                              <input type="text" class="form-control" placeholder="Recommended Package"
                                     id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                                     [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                                     name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="100" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row  ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Counselling Doctor</label>
                            </div>


                            <div class="col-md-5">
                              <input type="text" class="form-control" placeholder="Counselling Doctor"
                                     id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                                     [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                                     name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                                     maxlength="100" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Package Cost</label>
                            </div>

                            <div class="col-md-5">
                              <input type="number" class="form-control" placeholder="Package Cost"
                                     id="CurrentSaveCounsellingPlanRequest.PackageCost"
                                     [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                                     name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                            </div>
                            <!--<div class="col-md-3 text-align-right margin-top-7px">
          <label for="diaplayname" class="font-size-12px margin-bottom-0px">emi option</label>
        </div>-->
                            <!--<div class="col-md-2">
          <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


        </div>-->
                          </div>


                        </div>
                      </div>
                      <div class="row ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-top-7px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                            </div>

                            <div class="col-md-5">
                              <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                                     [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row">
    <div class="form-group col-md-6 col-xs-12 ">
      <label for="eventInput5" class="radio-inline">Emi Option</label>

      <input type="checkbox" class="form-control" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
             [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">



    </div>
  </div>-->
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                            </div>

                            <div class="col-md-5">
                              <CodeTypeValue CodeType="FNSTS"
                                             id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                             [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                             name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                            </div>

                            <div class="col-md-5">
                              <CodeTypeValue CodeType="PTNT"
                                             id="CurrentSaveCounsellingPlanRequest.Potential"
                                             [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                             name="CurrentSaveCounsellingPlanRequest.Potential">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10 ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                            </div>


                            <div class="col-md-5">
                              <CodeTypeValue CodeType="PNSTS"
                                             id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                             [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                             name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                              </CodeTypeValue>


                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row ">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 text-align-right">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>

                            <div class="col-md-6 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveCounsellingPlanRequest.Concerns"
                                        [(ngModel)]="CurrentSaveCounsellingPlanRequest.Concerns" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row float-right">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px" (click)="activeModal.close('Close click')">Cancel</button>
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting && isvisible'  class="btn font-size-13px actions-btn-prime">Save</button>
                      </div>
                    </div>

                  </form>
                </div>
                <div class="tab-pane" id="details">
                  <div class="card">
                    <div class="card-body padding-left-0px padding-right-0px padding-bottom-0px margin-left-0px padding-top-0px">
                      <div class="row" *ngIf="ShowList">
                        <div class="col-md-12">
                          <div class="table-component">
                            <div class="table-responsive overflow-x">


                              <table class="table table-striped margin-left-zero"
                                     cols="auto,2*,*,*,*,*,*,*">

                                <thead class="">
                                  <tr>

                                    <th class="">
                                      Start Date
                                    </th>
                                    <!--<th class="text-align-center">Day</th>-->

                                    <th class="">
                                      Plan
                                    </th>
                                    <th class="">
                                      End Date
                                    </th>
                                    <!--<th class="text-align-center">Start Time</th>-->
                                    <th class="">
                                      Status
                                    </th>

                                    <th class="">

                                    </th>




                                  </tr>
                                </thead>

                                <tbody class="table-body">
                                  <tr *ngFor="let l of CurrentCounsellingPlanController">



                                    <td class="td-padding text-align-center">
                                      <div [ngSwitch]="l.PlanStatus">
                                        <div *ngSwitchCase="'Created'" class="td-border-8px-green">
                                          {{l.StartDate| date:'MMM-dd-yyyy'}}
                                        </div>
                                        <div *ngSwitchCase="'Active'" class="td-brorder-8px-blue">
                                          <label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>
                                        </div>
                                        <div *ngSwitchCase="''" class="td-brorder-8px-blue">
                                          {{l.StartDate| date:'MMM-dd-yyyy'}}
                                        </div>
                                      </div>

                                       
                                    </td>
                                    <td class="">{{l.TreatmentPlan}}</td>
                                    <!--<td class="td-padding text-align-center"></td>-->
                                    <td class=" ">{{l.EndDate| date:'MMM-dd-yyyy'}}</td>
                                    <td class="  ">{{l.PlanStatus}}</td>


                                    <td>
                                      <div class="row">
                                        <a (click)="edit(l)" class="nav-link-hand education-navlink" title="Edit">
                                          <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                        </a>

                                      </div>
                                    </td>



                                  </tr>

                                </tbody>

                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" *ngIf="isEdit">
                        <div class="col-md-12">
                          <form class="form " novalidate="" (ngSubmit)="onEditSubmit()" #f="ngForm">
                            <div class="row margin-top-10 ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px"><span>*</span>Branch</label>
                                  </div>:


                                  <div class="col-md-5">
                                    <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                           id="CurrentEditCounsellingPalnRequest.BranchCode" SelectedValue="CurrentEditCounsellingPalnRequest.BranchCode"
                           [(ngModel)]="CurrentEditCounsellingPalnRequest.BranchCode" (keyChange)="onAssignedToActorCode($event)"
                           name="CurrentEditCounsellingPalnRequest.BranchCode" required>
  </CustomDataByRequestType>-->

                                    <label class="margin-bottom-0px font-size-12px margin-top-3px">{{FacilityName}}</label>
                                  </div>
                                
                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px"><span>*</span>Choose Treatment Plan</label>
                                  </div>:


                                  <div class="col-md-5">
                                    <!--<CodeTypeValue CodeType="CNSPN"
                 id="CurrentEditCounsellingPalnRequest.TreatmentPlan"
                 [(ngModel)]="CurrentEditCounsellingPalnRequest.TreatmentPlan" SelectedValue="CurrentEditCounsellingPalnRequest.TreatmentPlan"
                 name="CurrentEditCounsellingPalnRequest.TreatmentPlan" required>

  </CodeTypeValue>-->
                                    <label class="margin-bottom-0px font-size-12px margin-top-3px">{{CurrentEditCounsellingPalnRequest.TreatmentPlan}}</label>

                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                                  </div>


                                  <div class="col-md-5">
                                    <div class="date-form">
                                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                      <a (click)="d.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>

                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row  ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                                  </div>


                                  <div class="col-md-5">
                                    <input type="text" class="form-control" placeholder="Recommended Package"
                                           id="CurrentEditCounsellingPalnRequest.RecommendedPackage"
                                           [(ngModel)]="CurrentEditCounsellingPalnRequest.RecommendedPackage" required
                                           name="CurrentEditCounsellingPalnRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                           maxlength="100" />
                                    <small class="form-text text-danger"
                                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row  ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Counselling Doctor</label>
                                  </div>


                                  <div class="col-md-5">
                                    <input type="text" class="form-control" placeholder="Counselling Doctor"
                                           id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                           [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                           name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                           maxlength="100" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>
                                    <!--<input type="text" class="form-control" placeholder="Counselling Doctor"
          id="Doctor"
          [(ngModel)]="Doctor"
          name="Doctor" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Doctor="ngModel" maxlength="20" min="4"/>-->


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Package Cost</label>
                                  </div>

                                  <div class="col-md-5">
                                    <input type="number" class="form-control" placeholder="Package Cost"
                                           id="CurrentEditCounsellingPalnRequest.PackageCost"
                                           [(ngModel)]="CurrentEditCounsellingPalnRequest.PackageCost"
                                           name="CurrentEditCounsellingPalnRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>

                                  </div>
                                  <!--<div class="col-md-3 text-align-right margin-top-7px">
          <label for="diaplayname" class="font-size-12px margin-bottom-0px">emi option</label>
        </div>-->
                                  <!--<div class="col-md-2">
          <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


        </div>-->
                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-top-7px">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                                  </div>

                                  <div class="col-md-5">
                                    <input type="checkbox" class="form-control width-14px" id="CurrentEditCounsellingPalnRequest.SelectEmi"
                                           [(ngModel)]="CurrentEditCounsellingPalnRequest.SelectEmi" name="CurrentEditCounsellingPalnRequest.SelectEmi">


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                                  </div>

                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="FNSTS"
                                                   id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                   [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                   name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                    </CodeTypeValue>
                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                                  </div>

                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="PTNT"
                                                   id="CurrentEditCounsellingPalnRequest.Potential"
                                                   [(ngModel)]="CurrentEditCounsellingPalnRequest.Potential" SelectedValue="CurrentEditCounsellingPalnRequest.Potential"
                                                   name="CurrentEditCounsellingPalnRequest.Potential">
                                    </CodeTypeValue>
                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row margin-top-10 ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                                  </div>


                                  <div class="col-md-5">
                                    <CodeTypeValue CodeType="PNSTS"
                                                   id="CurrentEditCounsellingPalnRequest.PlanStatus"
                                                   [(ngModel)]="CurrentEditCounsellingPalnRequest.PlanStatus" SelectedValue="CurrentEditCounsellingPalnRequest.PlanStatus"
                                                   name="CurrentEditCounsellingPalnRequest.PlanStatus">

                                    </CodeTypeValue>


                                  </div>
                                </div>


                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right margin-tg-auto ">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End </label>
                                  </div>


                                  <div class="col-md-5">

                                    <div class="date-form">
                                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                      <a (click)="d1.toggle()" class="nav-link-hand">
                                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                      </a>

                                    </div>

                                  </div>

                                </div>


                              </div>
                            </div>
                            <div class="row ">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-4 text-align-right">
                                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                                  </div>

                                  <div class="col-md-6 padding-right-0px">
                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                              name="CurrentEditCounsellingPalnRequest.Concerns"
                                              [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                              #addconcerns_text="ngModel"></textarea>
                                    <small class="form-text text-danger"
                                           *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                                  </div>
                                </div>


                              </div>
                            </div>

                            <div class="row margin-top-14p float-right">
                              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" (click)="back()">Cancel</button>
                              <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                            </div>


                          </form>
                        </div>
                      </div>
                    </div>
                  </div>


                  <!--<div class="row" *ngFor="let p of CurrentCounsellingPlanController">
            <label>{{p.TreatmentPlan}} - {{p.StartDate}}</label>
          </div>-->





                </div>
              </div>
            </div>
          </div>



        </div>
      <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
        <button type="submit" class="btn font-size-13px actions-btn-prime">Save</button>
      </div>-->
   
  </div>
</div>
